<template>
  <checkbox-list
    v-model="selectedTypes"
    :columns="columns"
    :options="filterOptions"
    :field-name="fieldName"
  />
</template>
<script>
import CheckboxList from '#src/components/utils/fields/CheckboxList.vue'

export default {
  components: {
    CheckboxList
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    columns: {
      type: Number,
      default: 1,
      validator: prop => Number.isInteger(prop) && prop > 0
    },
    filterOptions: {
      type: Array,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    selectedTypes: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  }
}
</script>
